/*
 * @Author: 邱狮杰
 * @Date: 2022-09-27 11:57:53
 * @LastEditTime: 2022-11-10 14:45:58
 * @Description:
 * @FilePath: /superbridal-repo/packages/service/src/api/customer/update.ts
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// import { injectable } from 'inversify'
import { provide } from 'inversify-binding-decorators';
import { http } from '../../config';
import { customerConstant } from './customer';
// @injectable()
let CustomerUpdate = class CustomerUpdate {
    customerHandover(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield http({
                method: 'PUT',
                url: "/system/store/client/business/case/handOver",
                data: params
            });
        });
    }
    putbatchAllocation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield http({
                method: 'PUT',
                url: "/system/store/client/business/case/distribution",
                data: params
            });
        });
    }
    addRecord(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield http({
                method: 'POST',
                url: "/system/store/client/business/relation/record",
                data: params
            });
        });
    }
    updateCustomerRemark(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield http({
                method: 'PUT',
                url: "/system/store/client/business/remarks",
                data: params
            });
        });
    }
    updateCustomerCaseHasClient(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield http({
                method: 'PUT',
                url: "/system/store/client/business/caseHasClient",
                data: params
            });
        });
    }
    cancelBackRecord(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield http({
                method: 'POST',
                url: "/system/store/client/business/relation/record/cancelCallAt",
                data: params
            });
        });
    }
};
CustomerUpdate = __decorate([
    provide(customerConstant.createUpdate)
], CustomerUpdate);
export { CustomerUpdate };
